var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('img',{attrs:{"id":"spinner","src":require("@img/spinner.svg")}}):_vm._e(),_vm._v(" "),(!_vm.loading)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }